import { ChartLineUp, ThumbsUp, Target, Plant } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { Flow } from "../diagrams";
import { MasteryBadge } from "../../library/progress";

const TIMES = ["Today", "This Week", "This Month", "This Year", "Lifetime"];

const MASTERY_JOURNEY = [
  { icon: Plant, label: "Seed", desc: "Just started — first attempts", tone: "neutral" },
  { icon: Plant, label: "Growing", desc: "Getting the hang of it", tone: "teal" },
  { icon: Plant, label: "Strong", desc: "Confident and consistent", tone: "blue" },
  { icon: Plant, label: "Mastered", desc: "In full bloom", tone: "orange" },
];

export function ProgressSection() {
  return (
    <SectionShell
      id="progress"
      eyebrow="Progress"
      eyebrowIcon={ChartLineUp}
      title="Growth you can feel, over time"
      description="Progress tells the story of a child's growth across many time horizons — and shows it as a journey of blooming mastery, not a cold percentage."
    >
      <div className="space-y-8">
        <Showcase title="Many time dimensions" description="Zoom from a single day out to a whole learning life" tone="muted">
          <div className="flex flex-wrap gap-2">
            {TIMES.map((t, i) => (
              <span key={t} className={`rounded-full px-4 py-2.5 text-sm font-bold ${i === 0 ? "bg-primary text-primary-foreground shadow-soft" : "bg-card text-foreground shadow-soft"}`}>{t}</span>
            ))}
          </div>
        </Showcase>

        <Showcase title="Mastery is a journey" description="Seed → Growing → Strong → Mastered (per topic)">
          <Flow steps={MASTERY_JOURNEY} />
          <div className="mt-5 flex flex-wrap gap-2">
            <MasteryBadge level="seed" />
            <MasteryBadge level="growing" />
            <MasteryBadge level="strong" />
            <MasteryBadge level="mastered" />
          </div>
        </Showcase>

        <div className="grid gap-5 sm:grid-cols-2">
          <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal/15 text-teal-ink"><ThumbsUp size={24} weight="fill" /></span>
            <p className="mt-3 font-display text-xl font-extrabold">Strengths</p>
            <p className="mt-1 font-medium leading-relaxed text-muted-foreground">Celebrate what's blooming — “You're brilliant at addition!” — to build identity and confidence.</p>
          </div>
          <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/12 text-primary-strong"><Target size={24} weight="fill" /></span>
            <p className="mt-3 font-display text-xl font-extrabold">Areas to grow</p>
            <p className="mt-1 font-medium leading-relaxed text-muted-foreground">Framed as friendly next adventures — “Let's grow fractions next” — never as failings.</p>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default ProgressSection;
